const FixedSidebar = require('./FixedSidebar.json')
const BoardingGroupModal = require('./BoardingGroupModal.json')
const ChangeBoardingSlotModal = require('./ChangeBoardingSlotModal.json')
const Navbar = require('./Navbar.json')
const AnnouncementModal = require('./AnnouncementModal.json')

export default {
  ...FixedSidebar,
  ...BoardingGroupModal,
  ...ChangeBoardingSlotModal,
  ...Navbar,
  ...AnnouncementModal
}
